export default __webpack_public_path__ + "static/media/checkIcon.cb7abfe5.svg";